import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useLocation} from '@s-ui/react-router'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {STEPS} from '../../../index.js'

const usePublishMyAdWithPlateAnalyticsTrack = ({pageName} = {}) => {
  const {page: pageTrack, track} = useAnalyticsTrack()
  const {domain} = useContext(Context)
  const {query} = useLocation()

  const {reintentar: isUserRetrying} = query

  const {fieldNameToTrackingIds, formFieldIds} = domain.get('config').get('form')

  const errorTypes = {
    fieldError: 'fieldError',
    notMyCar: 'vehiculo no identificado',
    vehicleNotFound: 'informacion no recibida',
    versionNotSelected: 'version no seleccionada'
  }

  const getTrackingErrorData = ({errorType, fieldErrors = {}, isPrivacyChecked = true}) => {
    const data = {
      page_error: errorType
    }

    if (errorType === errorTypes.fieldError) {
      const fieldsWithError = Object.keys(fieldErrors).filter(fieldId => fieldErrors[fieldId]?.length > 0)
      const formFields = fieldsWithError
        .map(fieldToRename => fieldNameToTrackingIds[fieldToRename]?.property)
        .filter(Boolean)

      if (!isPrivacyChecked) {
        formFields.push(fieldNameToTrackingIds[formFieldIds.privacyCheck].property)
      }

      data.page_error = 'campo incorrecto'
      data.form_fields = formFields.join(':')
    }

    return data
  }

  const trackErrorPlate = ({errorType, fieldErrors, isPrivacyChecked}) => {
    const data = getTrackingErrorData({
      errorType,
      fieldErrors,
      isPrivacyChecked
    })

    track({
      event: 'Ad Insertion Car Plate Process Error',
      data
    })
  }

  const trackFormFieldSelected = ({fieldId}) => {
    track({
      event: `Ad Insertion ${fieldNameToTrackingIds[fieldId].field} Selected`
    })
  }

  const trackMoreOptionsClicked = () => {
    track({
      event: `Ad Insertion Car Plate Process More Options Clicked`
    })
  }

  const trackPageViewed = async () => {
    const pageTrackingData = await domain.get('get_page_tracking_data_use_case').execute({
      isRetry: isUserRetrying === 'true',
      page: pageName,
      step: STEPS.formSellerPlate
    })

    pageTrack(pageTrackingData)
  }

  const trackReceiveVehicleData = () => {
    track({
      event: 'Ad Insertion Car Plate Process Success'
    })
  }

  const trackShowResultsVehicleData = ({resultsNumber}) => {
    pageTrack({
      event: `Ad Insertion Viewed`,
      data: {
        channel: 'ad post',
        page_category_level1: 'crear anuncio',
        page_name: 'proceso matricula resultado',
        page_type: 'form',
        search_result_number: Number(resultsNumber)
      }
    })
  }

  return {
    errorTypes,
    trackErrorPlate,
    trackFormFieldSelected,
    trackMoreOptionsClicked,
    trackPageViewed,
    trackReceiveVehicleData,
    trackShowResultsVehicleData
  }
}

export {usePublishMyAdWithPlateAnalyticsTrack}
